/*!
 * Built by Revolist
 */
import { R as RevogrRowHeaders$1, d as defineCustomElement$1 } from './revogr-row-headers2.js';

const RevogrRowHeaders = RevogrRowHeaders$1;
const defineCustomElement = defineCustomElement$1;

export { RevogrRowHeaders, defineCustomElement };
